import type { ParamMatcher } from '@sveltejs/kit'

export const match: ParamMatcher = (param) =>
  // This was the old format
  /^([\da-fA-F]+)(-[\da-fA-F]+){4}$/.test(param) ||
  // This is the new format
  /^([\da-zA-Z]{10,})$/.test(param)
